import { useEffect, useState } from 'react';

const clarityKey = import.meta.env.VITE_CLARITY_KEY;
const mode = import.meta.env.MODE;

const useClarity = () => {
    const [isClarityLoaded, setIsClarityLoaded] = useState(false);

    useEffect(() => {
        if (isClarityLoaded || !clarityKey || mode !== 'production') return;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = `
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${clarityKey}");
    `;
        document.head.appendChild(script);
        setIsClarityLoaded(true);

        return () => {
            document.head.removeChild(script);
        };
    }, [isClarityLoaded]);

    return isClarityLoaded;
};

export default useClarity;
